module.exports = __webpack_public_path__ + "static/media/Towns Lecture Hall.de0e030b.png";